import { SignedInStatusContext } from '@/context/SignedInStatusContext'
import { useContext } from 'react'

export default function useClientSideSignedInData() {
  const clientSideSignedInData = useContext(SignedInStatusContext)
  if (!clientSideSignedInData) {
    return {
      signedIn: false,
      firstName: undefined,
      email: undefined,
    } as const
  }
  return {
    signedIn: true,
    ...clientSideSignedInData,
  } as const
}
